import { ReactNode } from "react";

type LargeOptionCardProps = {
  icon: ReactNode;
  title: string;
  selected: boolean;
  onSelect: () => void;
};
function cleanLabel(value: string) {
  if (!value) return;
  return value.replace(/^"+|"+$/g, "");
}

export function LargeOptionCard({
  icon,
  title,
  selected,
  onSelect,
}: LargeOptionCardProps) {
  return (
    <button
      type="button"
      onClick={onSelect}
      className={`
        relative w-full rounded-2xl border p-5 sm:p-6
        flex flex-col items-center justify-center gap-4
        bg-white shadow-sm transition
        hover:shadow-md
        ${
          selected
            ? "border-[var(--brand)] bg-[var(--brand-soft)]/40"
            : "border-[var(--line)] hover:border-gray-300"
        }
      `}
    >
      <span className="absolute top-4 right-4">
        {selected ? (
          <span className="block h-5 w-5 rounded-full border-2 border-white bg-[var(--brand)] shadow-sm" />
        ) : (
          <span className="block h-5 w-5 rounded-full border border-gray-300" />
        )}
      </span>

      <div
        className={`
          flex h-14 w-14 items-center justify-center rounded-xl
          ${
            selected
              ? "bg-[var(--brand-soft)] text-[var(--brand)]"
              : "bg-gray-100 text-gray-600"
          }
        `}
      >
        {icon}
      </div>

      <div className="text-center font-semibold text-[var(--text-primary)]">
        {cleanLabel(title)}
      </div>
    </button>
  );
}
